import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {

  resetUserPassword( {dispatch}, obj) {
    return new Promise((resolve, reject) => {
      axios.post('/admin/change-password', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },   
  getUserlist({ state, commit }) {
    axios.get('admin/user-list')
      .then(response => {
        state.userList = response.data
        commit('setUserList', response.data)
      }).catch((err) => {
      })
  }
  
}
